import { useState } from 'react';
import { toast } from 'sonner';
import { BarChart3 } from 'lucide-react';
import { funnelStats } from '../lib/license';

const STEPS = ['open', 'setup_shown', 'setup_done', 'tour_done', 'tour_skip', 'first_project'];

// owner view: how many devices reach each onboarding step and stay active
export default function FunnelStats({ t }) {
  const [d, setD] = useState(null);
  const load = async () => { try { setD(await funnelStats()); } catch (e) { toast.error(e.message === 'owner' ? t.ownerExpired : t.licOffline); } };
  const pct = (n) => (d?.devices ? ` (${Math.round((n / d.devices) * 100)} %)` : '');
  return (
    <section className="fn-box" data-testid="funnel-section">
      <button className="btn btn-outline btn-sm" data-testid="funnel-load-btn" onClick={load}><BarChart3 size={15} /> {t.fnTitle}</button>
      {d && (
        <div className="fn-grid" data-testid="funnel-stats">
          <p><b>{t.fnDevices}: {d.devices}</b></p>
          {STEPS.map((s) => <p key={s} data-testid={`funnel-step-${s}`}>{t['fn_' + s]}: <b>{d.steps[s] || 0}</b>{pct(d.steps[s] || 0)}</p>)}
          <p className="muted">{t.fnActive}</p>
          {Object.entries(d.active_after_days).map(([n, c]) => <p key={n} data-testid={`funnel-active-${n}`}>≥ {n} {t.fnDays}: <b>{c}</b>{pct(c)}</p>)}
          <p className="muted" data-testid="funnel-langs">{Object.entries(d.langs).map(([l, c]) => `${l.toUpperCase()} ${c}`).join(' · ')}</p>
        </div>
      )}
    </section>
  );
}
